import { useIsAuthenticated as useMsalIsAuthenticated } from '@azure/msal-react';

const useIsAuthenticated = (): boolean => useMsalIsAuthenticated();

export default useIsAuthenticated;
